import React, { useState } from 'react'
import { intCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo, monthsMap } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'

import { connect } from 'react-redux'
import {
  getMisoVerificationSeason,
  updateMisoVerificationSeason,
  deleteMisoVerificationSeason,
} from 'api/pgads.js'
import { Button, Select, InputNumber } from 'antd'

import CommonScreen from './CommonScreen'
import { Label } from 'core/screen-util'
import { monthMapChoice } from 'core/utils'

const MisoVerificationSeason = _ => {
  const title = 'Verification Season'
  const [insertEvent, setInsertEvent] = useState(false)

  const MonthSelection = ({ value, onChange }) => (
    <Select value={value} onChange={onChange}>
      {Object.keys(monthsMap).map(i => (
        <Select.Option value={i} key={i}>
          {monthsMap[i]}
        </Select.Option>
      ))}
    </Select>
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gap: '5px',
        gridTemplateColumns:
          '120px 150px 120px 150px 120px 150px 120px 150px 80px 100px',
      }}
    >
      <Label>Effective Year : </Label>
      <InputNumber
        value={insertData.effectiveYear}
        onChange={effectiveYear =>
          setInsertData({ ...insertData, effectiveYear })
        }
        style={{ width: '100%' }}
      />
      <Label>Summer Start : </Label>
      <MonthSelection
        value={insertData.summerStartMonth}
        onChange={val =>
          setInsertData({ ...insertData, summerStartMonth: val })
        }
      />
      <Label>Summer End : </Label>
      <MonthSelection
        value={insertData.summerEndMonth}
        onChange={val => setInsertData({ ...insertData, summerEndMonth: val })}
      />

      <Label>Fall Start : </Label>
      <MonthSelection
        value={insertData.fallStartMonth}
        onChange={val => setInsertData({ ...insertData, fallStartMonth: val })}
      />

      <Label>Fall End : </Label>
      <MonthSelection
        value={insertData.fallEndMonth}
        onChange={val => setInsertData({ ...insertData, fallEndMonth: val })}
      />
      <Label>Winter Start : </Label>
      <MonthSelection
        value={insertData.winterStartMonth}
        onChange={val =>
          setInsertData({ ...insertData, winterStartMonth: val })
        }
      />
      <Label>Winter End : </Label>
      <MonthSelection
        value={insertData.winterEndMonth}
        onChange={val => setInsertData({ ...insertData, winterEndMonth: val })}
      />

      <Label>Spring Start : </Label>
      <MonthSelection
        value={insertData.springStartMonth}
        onChange={val =>
          setInsertData({ ...insertData, springStartMonth: val })
        }
      />
      <Label>Spring End : </Label>
      <MonthSelection
        value={insertData.springEndMonth}
        onChange={val => setInsertData({ ...insertData, springEndMonth: val })}
      />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          gap: '5px',
          gridColumnEnd: 'span 2',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
  return (
    <CommonScreen
      title={title}
      header={VerificationSeasonHeaders}
      saveTask={updateMisoVerificationSeason}
      retrieveTask={getMisoVerificationSeason}
      deleteTask={deleteMisoVerificationSeason}
      altBy={d => d.unit}
      autoRetrieve
      sortOptions={VerificationSeasonHeaders}
      widthOffset={50}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(MisoVerificationSeason)

const VerificationSeasonHeaders = [
  intCol({
    ident: 'effectiveYear',
    display: 'Effective Year',
    isKey: true,
    width: 120,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'summerStartMonth',
    display: 'Summer Start Month',
    isFiltered: true,
    width: 150,

    ...monthMapChoice,
  }),
  intCol({
    ident: 'summerEndMonth',
    display: 'Summer End Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),
  intCol({
    ident: 'fallStartMonth',
    display: 'Fall Start Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),
  intCol({
    ident: 'fallEndMonth',
    display: 'Fall End Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),
  intCol({
    ident: 'winterStartMonth',
    display: 'Winter Start Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),
  intCol({
    ident: 'winterEndMonth',
    display: 'Winter End Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),
  intCol({
    ident: 'springStartMonth',
    display: 'Spring Start Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),
  intCol({
    ident: 'springEndMonth',
    display: 'Spring End Month',
    isFiltered: true,
    width: 150,
    ...monthMapChoice,
  }),

  modifierCol,
  modifiedDateCol,
]
